import Vue from 'vue';
import Component from 'vue-class-component';

import moment from 'common/deps/moment';
import currency from 'common/filters/currency';

Vue.filter('currency', currency);
@Component({
  props: {
    clientDataStep: {
      type: Object,
      required: true,
      description: 'data from previus step',
    },
    selectDateStep: {
      type: Object,
      required: true,
      description: 'data from first step',
    },
    loading: {
      type: Boolean,
    },
    reservationError: {
      type: String,
    },
    isReservationBuy: {
      type: Boolean,
      default: false,
    },
    activity: {
      type: Object,
      required: true,
    },
  },
})
export default class CatalogReservationConfirmationComponent extends Vue {
  reservationBuyDisclaimerAccepted = false
  reservationBuyDisclaimerError = false

  getDateFormatted() {
    const { date, appointment } = this.selectDateStep;

    /* This line is to avoid console errors when moving accross the steps and changing data */
    if (!appointment) return new Date();

    let date_ = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY - H:mm a',
    );

    let dateFormated = moment(`${date.date}T${appointment.time}`).format(
      'DD/MM/YYYY',
    );

    if (appointment.end_time) {
      let date_init = moment(appointment.time, 'HH:mm:ss').format('H:mm a');
      let date_range = moment(appointment.end_time, 'HH:mm:ss').format(
        'H:mm a',
      );
      date_ = `${dateFormated} - llegada entre las ${date_init} y las ${date_range}`;
    }

    return `${date_}`;
  }

  get ctaLabel() {
    return this.isReservationBuy ? 'Agregar al carrito' : 'Confirmar reserva';
  }

  emitSubmit() {
    if (this.loading) { return }
    if (this.isReservationBuy && !this.reservationBuyDisclaimerAccepted) {
      this.reservationBuyDisclaimerError = true
      return
    }
    this.$emit('createReservation');
  }
}
